import axios, { CancelTokenSource, AxiosError } from 'axios';
import history from 'services/history';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.universoplastica.com.br/api/',
});

const globalApi = axios.create({
  baseURL: 'https://teste.ddns.net:8500/api/',
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('universo-plastica@token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (err: AxiosError) => {
    return Promise.reject(err);
  },
);

api.interceptors.response.use(
  config => {
    return config;
  },
  err => {
    if ((err.response && err.response.status === 401) || err.response.data.message === 'Unauthenticated.') {
      localStorage.removeItem('universo-plastica@token');
      history.push('/login');
      return Promise.reject(err);
    }
    return Promise.reject(err);
  },
);

export function getCancelTokenSource(): CancelTokenSource {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  return source;
}

export { api, globalApi };
